var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerMaster(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1578_12819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1622 14.0918L14.1153 17.9979L14.3686 18.5047L13.9504 18.8869L11.506 21.1212L11.365 21.25H18.7946C18.7475 19.6689 18.5403 18.0015 18.012 16.514C17.4569 14.9509 16.5618 13.6222 15.1501 12.7726C14.2735 13.4498 13.2473 13.9013 12.1622 14.0918ZM3.20538 21.25H10.635L10.494 21.1212L8.04955 18.8869L7.63134 18.5047L7.88472 17.9979L9.83777 14.0918C8.75271 13.9013 7.72648 13.4498 6.8499 12.7726C5.43815 13.6222 4.54308 14.9509 3.98795 16.514C3.45968 18.0015 3.25245 19.6689 3.20538 21.25ZM11 11.4722C12.0603 11.4722 13.0968 11.1578 13.9785 10.5687C14.8601 9.97963 15.5472 9.14234 15.953 8.16272C16.3588 7.18311 16.4649 6.10517 16.2581 5.06521C16.0512 4.02526 15.5406 3.07 14.7909 2.32024C14.0411 1.57047 13.0858 1.05987 12.0459 0.853015C11.0059 0.646155 9.92799 0.752323 8.94838 1.15809C7.96876 1.56386 7.13147 2.25101 6.54238 3.13264C5.9533 4.01427 5.63887 5.05079 5.63887 6.11111C5.63887 6.81515 5.77754 7.51228 6.04696 8.16272C6.31638 8.81316 6.71128 9.40417 7.20911 9.90199C7.70693 10.3998 8.29794 10.7947 8.94838 11.0641C9.59882 11.3336 10.296 11.4722 11 11.4722Z",
    stroke: "white",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1578_12819"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "matrix(-1 0 0 1 22 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerMaster);
export default __webpack_public_path__ + "static/media/Customer Master.239d9df9715e2a7ef23ebed2f4ca0d1c.svg";
export { ForwardRef as ReactComponent };